import * as student from './student';
import * as qcrb from './qcrb';
import * as jpProcess from './jp_process';
import * as krProcess from './kr_process';
import * as langSchoolProcess from './langschool_process';
import * as training from './training';
import * as common from './common';
import * as visit from './visit';
import * as interview from './interview';
import * as interviewForm from './interview_form';
import * as activity from './activity';
import * as teaching from './teaching';

export default {
  common,
  student,
  qcrb,
  jp_process: jpProcess,
  kr_process: krProcess,
  langschool_process: langSchoolProcess,
  training,
  visit,
  interview,
  interviewForm,
  activity,
  teaching,
};
